var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1126,
    height: 689,
    viewBox: "0 0 1126 689",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.551 439.429C-43.9974 606.617 72.0982 576.704 194.544 652.259C298.028 716.114 474.42 666.703 607.502 666.708C890.749 666.72 976.454 748.646 1068.84 595.971C1181.38 409.978 1117.4 184.486 967.042 89.4529C779.088 -29.3389 680.066 1.85915 576.628 9.05867C473.19 16.2581 411.38 106.252 384.89 242.243C358.4 378.233 77.0994 272.241 16.551 439.429Z",
    fill: "#FAEACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm2);
export default __webpack_public_path__ + "static/media/form2.dd1c6acf8eed821b2abac2cb2d5800f9.svg";
export { ForwardRef as ReactComponent };